module.exports = __webpack_public_path__ + "img/list-outline-white.446bf1e1.svg";